module.exports = __webpack_public_path__ + "img/call-background.419ee1f4.png";